import React from 'react';
import $ from "jquery";
import AppServer from '../../../functions/servername';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import { Image } from 'semantic-ui-react';

class SparesDetails extends React.Component {

    state = {
        opensparesDetailDialog: false,
        data: [], part: [], related: []
    }

    getSparesDetails() {
        let context = this;
        $.ajax({
            type: 'POST', data: { 'partno': context.props.partno },
            url: AppServer() + 'ui/getpartinfo.php',
            success: function(data) {
                let part = [];
                let images = [];
                let related = [];
                try {
                    data = JSON.parse(data);
                    let related = data.related;
                    console.log(related);
                    context.setState({ part: data.part, related: data.related, images: data.images, opensparesDetailDialog: true })
                } catch (error) {
                    
                }
            },
            error: function(err) {
                alert('Try again!!!!')
            }
        });
    }

    render() {
        return (
            <div>
                <div style={{cursor: 'pointer', color: 'blue'}} onClick={this.getSparesDetails.bind(this)}>Spare Details</div>
                <Dialog  fullWidth={true}
                    maxWidth={'sm'}  open={this.state.opensparesDetailDialog}
                    onClose={ () =>  { this.setState({ opensparesDetailDialog: false }) }} aria-labelledby="max-width-dialog-title">
                    <DialogTitle id="max-width-dialog-title">Spares Details</DialogTitle>
                    <DialogContent>
                        <Image refs="scrolldiv" src={"https://s3.ap-south-1.amazonaws.com/vaigaiclaas.com/feature/"+this.props.partno+".jpg"} style={{width: '100%', height: '30%'}} />
                        <h4>Highlights</h4>

                        <div style={{borderColor: 'black', borderStyle: 'solid', borderWidth: '1px', padding: '1%', borderRadius: '3px'}}>
                                    <b>Description</b>
                                    <div>{this.state.part.description}</div>
                                    <br/>
                                    <b>Feature And Details</b>
                                    <div>
                                        <div style={{display: 'flex', width: '100%'}}>
                                            <div style={{width: '30%'}}><b>Tamil Name</b></div>
                                            <div style={{width: '70%'}}>{this.state.part.tamil_name}</div>
                                        </div>

                                        <div style={{display: 'flex', width: '100%'}}>
                                            <div style={{width: '30%'}}><b>Local Name</b></div>
                                            <div style={{width: '70%'}}>{this.state.part.local_name}</div>
                                        </div>

                                        <div style={{display: 'flex', width: '100%'}}>
                                            <div style={{width: '30%'}}><b>Part Number</b></div>
                                            <div style={{width: '70%'}}>{this.props.partno}</div>
                                        </div>

                                        <div style={{display: 'flex', width: '100%'}}>
                                            <div style={{width: '30%'}}><b>Machine Support</b></div>
                                            <div style={{width: '70%'}}>{this.state.part.from_serialno+' - '+this.state.part.to_serialno}</div>
                                        </div>

                                        <div style={{display: 'flex', width: '100%'}}>
                                            <div style={{width: '30%'}}><b>Weight of the product</b></div>
                                            <div style={{width: '70%'}}>{this.state.part.weight+' Kg(s)'}</div>
                                        </div>
                                    </div>
                                </div>
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={ () =>  { this.setState({ opensparesDetailDialog: false }) }} color="primary">
                            Close
                        </Button>
                    </DialogActions>
                </Dialog>
            </div>
        );
    }
}

export default SparesDetails;
